var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { createElement as _createElement } from "react";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useCallback, useRef } from 'react';
import classnames from 'classnames';
import { Box, Card, CardContent, Chip, InputLabel, Typography } from '@material-ui/core';
import useStyles from './style';
import CloseIcon from '@material-ui/icons/Close';
var START_CODE = String.fromCodePoint(0x200d);
var END_CODE = String.fromCodePoint(0x200c);
var START_CHIP_SEPARATOR = '[$';
var END_CHIP_SEPARATOR = ']';
var CHIP_SPLIT_REGEX = /(\[\$.*?\])/;
var TextChipInput = function (_a) {
    var label = _a.label, placeholder = _a.placeholder, _b = _a.value, value = _b === void 0 ? '' : _b, _c = _a.type, type = _c === void 0 ? 'text' : _c, onInputChange = _a.onInputChange, labelProps = _a.labelProps, errorText = _a.errorText, _d = _a.disabled, disabled = _d === void 0 ? false : _d, rest = __rest(_a, ["label", "placeholder", "value", "type", "onInputChange", "labelProps", "errorText", "disabled"]);
    var splittedValue = value.split(CHIP_SPLIT_REGEX);
    var classes = useStyles();
    var handleBlur = useCallback(function (e) {
        var formattedText = getFormattedText(e.target.textContent);
        onInputChange(e, formattedText);
    }, [onInputChange]);
    var handleDelete = useCallback(function (e) {
        var textWrapper = e.currentTarget.parentElement;
        var index = Number.parseInt(textWrapper.dataset.index);
        var formattedText = getFormattedText(textWrapper.parentElement.textContent);
        var splittedText = formattedText.split(CHIP_SPLIT_REGEX);
        splittedText.splice(index, 1);
        e.currentTarget = textWrapper.parentElement;
        onInputChange(e, splittedText.join(''));
    }, [onInputChange]);
    var classNames = classnames(errorText && classes.errorBorder, type === 'text' ? classes.inputWrapper : classes.textareaWrapper, disabled && classes.disabled);
    var inputRef = useRef(null);
    return (_jsxs(_Fragment, { children: [_jsx(InputLabel, __assign({}, labelProps, { children: label }), void 0),
            _jsxs(Card, __assign({ className: classNames }, { children: [_jsx(CardContent, __assign({ className: "contenteditable", "data-testid": "text-chip-input-field", contentEditable: !disabled, onBlur: handleBlur, suppressContentEditableWarning: true, ref: inputRef }, rest, { children: splittedValue.map(function (item, index) { return (_jsx(React.Fragment, { children: item.startsWith(START_CHIP_SEPARATOR) && item.endsWith(END_CHIP_SEPARATOR) ? (_createElement(Chip, __assign({ className: classes.chip, "data-index": index, deleteIcon: _jsx(CloseIcon, { "data-testid": "delete-chip-btn" }, void 0) }, (disabled ? {} : { onDelete: handleDelete }), { contentEditable: false, key: index, label: item
                                    .replace(START_CHIP_SEPARATOR, START_CODE)
                                    .replace(END_CHIP_SEPARATOR, END_CODE) }))) : (item) }, index)); }) }), Math.random()),
                    _jsx("div", __assign({ contentEditable: false, className: classes.placeholder, onClick: function () {
                            // @ts-ignore
                            inputRef.current.focus();
                        } }, { children: placeholder }), void 0)] }), void 0),
            errorText && (_jsx(Box, __assign({ pt: 1 }, { children: _jsx(Typography, __assign({ color: "error", className: classes.error }, { children: errorText }), void 0) }), void 0))] }, void 0));
};
var getFormattedText = function (text) {
    if (text === void 0) { text = ''; }
    var startReg = new RegExp(START_CODE, 'g');
    var endReg = new RegExp(END_CODE, 'g');
    var result = text
        .replace(startReg, START_CHIP_SEPARATOR)
        .replace(endReg, END_CHIP_SEPARATOR)
        .replace(/\n/g, ' ');
    return result;
};
export default TextChipInput;
